import appParams from '../../../../params.json';

export function paramsHasErrored(state = false, action) {
    switch (action.type) {
        case 'PARAMS_HAS_ERRORED':
            return action.hasErrored;
        default:
            return state;
    }
}

export function paramsAreLoading(state = false, action) {
    switch (action.type) {
        case 'PARAMS_ARE_LOADING':
            return action.areLoading;
        default:
            return state;
    }
}

function processParam(param, key) {
    let precision;

    param.type = key.slice(0, 2);
    param.point = appParams[key].point;

    if (param.value != null) {
        // if (param.point !== null) {precision=param.point}
        precision = (param.point == null) ? 2 : param.point;
        let disabled, byteNumber;
        if (param.type === 'ti') {
            byteNumber = 7;
        }
        else {
            byteNumber = 3;
        }
        disabled = (param.flags & byteNumber) !== 0;

        return {
            cleaned: param.value,
            value: param.value.toFixed(precision),
            disabled: disabled,
        };
    }
    else {
        return {
            cleaned: 0,
            value: '?',
            disabled: true
        };
    }
}

export function params(state = {}, action) {
    switch (action.type) {
        case 'PARAMS_FETCH_DATA_SUCCESS':
            let {params} = action, processedParams = {};

            Object.keys(appParams).map(key => {

                    try {
                        let processedParam;
                        if (key in params) {
                            processedParam = processParam(params[key], key);
                        }
                        else {
                            processedParam = {
                                cleaned: 0,
                                value: '?',
                                disabled: true,
                                // firstload: true
                            };

                        }

                        processedParams[key] = processedParam;
                    }
                    catch (e) {
                        console.error(e.stack, key);
                    }
                    return null;
                }
            );
            return processedParams;

        case 'PARAM_WS_FETCH': {
            let newParObj = {};
            newParObj[action.paramwid.id] = processParam(action.paramwid.param, action.paramwid.id);
            return Object.assign({}, state, newParObj)
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/lib/redux/reducers/params.js